import { Component, ContentChild, EventEmitter, Input, Output } from '@angular/core';
import type { ApiError } from '@shared/http/errors/api-error';
import { toApiError } from '@shared/services/error-handler/parse';

@Component({
    selector: 'app-alert-api-error',
    templateUrl: './api-error-alert.component.html',
    styleUrls: ['./api-error-alert.component.scss']
})
export class ApiErrorAlertComponent {
    @ContentChild('message') message: any;

    public _error: any;
    public _apiError: ApiError;

    @Output() retry = new EventEmitter<void>();

    @Input() set error(value: any) {
        this._error = value;

        // Check if we're getting a new error object to avoid unnecessary parsing
        if (value !== this._error) {
            this._apiError = toApiError(value);
        }
    }
}
